export * from './cta';
export { Faqs } from './faqs';
export { ForYou } from './for-you';
export { Hero, HeroDark, HeroDarkV2, HeroV3 } from './hero';
export { LearnResult } from './learn-result';
export { Reviews } from './reviews';
export { SubscriptionsLazy } from './subscriptions';
export { Support } from './support';
export { TariffPlans } from './tariff-plans';
export * from './team';
export { TextMediaBlock } from './text-media-block';
export * from './text-media-carousel';
export { TrainingProgramm, TrainingProgrammV2 } from './training-programm';
export { TrainingTakes } from './training-takes';
export { TrainingTakesV2 } from './training-takes-v2';

// Экспорт типов
export type * from '../types';
